import { Link, Navigate, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useStateContext } from "../../Contexts/ContextProvider";
import AxiosClient from "../../assets/AxiosClient";

export default function AccountEdit() {
  const { user, isAuthenticated, setUser, SetNotification } = useStateContext();
  const navigate = useNavigate();

  const fnameRef = useRef();
  const lnameRef = useRef();
  const phoneRef = useRef();
  const user_Save = async (e) => {
    e.preventDefault();
    try {
      const response = await AxiosClient.put(`/Users/${user.id}`, {
        first_name: fnameRef.current.value,
        last_name: lnameRef.current.value,
        phone: phoneRef.current.value,
      });
      setUser(response.data.user);
      SetNotification("Your Information has been updated successfully", "success");
      navigate("/Account");
    } catch {
      SetNotification("Something bad happened!!", "danger");
    }
  };

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="col-12 col-xl-4">
      <div className="card card-plain h-100">
        <div className="card-header pb-0 p-3">
          <div className="row">
            <div className="col-md-8 d-flex align-items-center">
              <h6 className="mb-0">Profile Information</h6>
            </div>
            <div className="col-md-4 text-end"></div>
          </div>
        </div>
        <form className="card-body p-3" onSubmit={user_Save}>
          <p className="text-sm text-secondary">Update the personal information associated with your account.</p>
          <hr className="horizontal gray-light my-4" />
          <div className="row">
            <div className="col-md-6">
              <label className="form-label" htmlFor="account-first-name">First name</label>
              <div className="input-group input-group-outline mb-3">
                <input id="account-first-name" type="text" className="form-control" placeholder="First name" ref={fnameRef} defaultValue={user?.first_name || ""} required />
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="account-last-name">Last name</label>
              <div className="input-group input-group-outline mb-3">
                <input id="account-last-name" type="text" className="form-control" placeholder="Last name" ref={lnameRef} defaultValue={user?.last_name || ""} required />
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="account-phone">Mobile</label>
              <div className="input-group input-group-outline mb-3">
                <input id="account-phone" type="tel" className="form-control" placeholder="Phone number" ref={phoneRef} defaultValue={user?.phone || ""} />
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="account-email">Email</label>
              <div className="input-group input-group-outline mb-3">
                <input id="account-email" type="email" className="form-control" value={user?.email || ""} disabled readOnly />
              </div>
              <p className="text-xs text-secondary">Contact an administrator to change your email address.</p>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Link to="/Account/View" className="btn btn-outline-secondary mb-0">Cancel</Link>
            <button type="submit" className="btn bg-gradient-info mb-0">Save changes</button>
          </div>
        </form>
      </div>
    </div>
  );
}